"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortFunctionForArrayOfWaypoints = exports["default"] = exports.Procedure = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDatetimePicker = require("nicbase-datetime-picker");

var _nicbaseFilters = require("nicbase-filters");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../constants");

var _procedureStepModule = _interopRequireDefault(require("./procedure-step.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var parseStringToValidNumber = function parseStringToValidNumber(dirtyString) {
  if (dirtyString) {
    var result = parseInt(dirtyString.replace(/([^\d])/g, ''), 10);

    if (Number.isInteger(result)) {
      return result;
    }
  }

  return null;
};

var sortFunctionForArrayOfWaypoints = function sortFunctionForArrayOfWaypoints(waypoint1, waypoint2) {
  if (waypoint1.type === _constants.WAYPOINT_TYPES.START || waypoint2.type === _constants.WAYPOINT_TYPES.END) {
    return -1;
  }

  if (waypoint1.type === _constants.WAYPOINT_TYPES.END || waypoint2.type === _constants.WAYPOINT_TYPES.START) {
    return 1;
  }

  return 0;
};

exports.sortFunctionForArrayOfWaypoints = sortFunctionForArrayOfWaypoints;

var Procedure = function Procedure(_ref) {
  var tour = _ref.tour,
      errors = _ref.errors,
      touched = _ref.touched,
      onUpdate = _ref.onUpdate;

  var _useState = (0, _react.useState)(tour.wayPoints.length),
      _useState2 = _slicedToArray(_useState, 2),
      frontendWaypointId = _useState2[0],
      setFrontendWaypointId = _useState2[1];

  var _useUser = (0, _nicbaseReducers.useUser)(),
      locale = _useUser.locale,
      timezone = _useUser.timezone;

  var intl = (0, _nicbaseTranslation.useIntl)();

  var onPoiChange = function onPoiChange(poi, condition, intermediate) {
    var _tour$wayPoints = tour.wayPoints,
        wayPoints = _tour$wayPoints === void 0 ? [] : _tour$wayPoints;
    var waypointIndex = intermediate ? wayPoints.indexOf(intermediate) : wayPoints.findIndex(function (wayPoint) {
      return wayPoint.type === condition;
    });
    var editedWayPoints = wayPoints.slice(0);

    if (waypointIndex >= 0) {
      var _poi$id;

      var editedWaypoint = _objectSpread(_objectSpread({}, wayPoints[waypointIndex]), {
        poiId: (_poi$id = poi === null || poi === void 0 ? void 0 : poi.id) !== null && _poi$id !== void 0 ? _poi$id : null
      });

      editedWayPoints.splice(waypointIndex, 1, editedWaypoint);
    } else {
      var _poi$id2;

      var waypoint = {
        frontendId: condition,
        type: condition,
        poiId: (_poi$id2 = poi === null || poi === void 0 ? void 0 : poi.id) !== null && _poi$id2 !== void 0 ? _poi$id2 : null,
        poiTriggerCondition: _constants.TRIGGER_CONDITIONS.POI_EXITED
      };
      editedWayPoints.push(waypoint);
    }

    editedWayPoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: editedWayPoints,
      route: null
    });
  };

  var onDateChange = function onDateChange(date, condition, intermediate) {
    var _tour$wayPoints2 = tour.wayPoints,
        wayPoints = _tour$wayPoints2 === void 0 ? [] : _tour$wayPoints2;
    var waypointIndex = intermediate ? wayPoints.indexOf(intermediate) : wayPoints.findIndex(function (wayPoint) {
      return wayPoint.type === condition;
    });
    var editedWayPoints = wayPoints.slice(0);
    var timestamp = date ? date.toISOString() : null;

    var editedStartWaypoint = _objectSpread(_objectSpread({}, wayPoints[waypointIndex]), _defineProperty({}, condition === 'START' ? 'plannedStartTime' : 'scheduledTimeOfArrival', timestamp));

    editedWayPoints.splice(waypointIndex, 1, editedStartWaypoint);
    editedWayPoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: editedWayPoints
    });
  };

  var onAddClicked = function onAddClicked() {
    var newId = frontendWaypointId + 1;
    setFrontendWaypointId(newId);
    var newWaypoint = {
      frontendId: newId,
      type: _constants.WAYPOINT_TYPES.INTERMEDIATE,
      scheduledTimeOfArrival: null,
      plannedStopDuration: 10
    };
    var wayPoints = tour.wayPoints.concat(newWaypoint);
    wayPoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: wayPoints,
      route: null
    });
  };

  var onRemoveClicked = function onRemoveClicked(waypoint) {
    var waypointIndex = tour.wayPoints.indexOf(waypoint);
    var wayPoints = tour.wayPoints.slice(0);
    wayPoints.splice(waypointIndex, 1);
    wayPoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: wayPoints,
      route: null
    });
  };

  var onEarliestStartTimeChanged = function onEarliestStartTimeChanged(selectedDate) {
    var earliestStartTime = selectedDate ? selectedDate.toISOString() : null;
    onUpdate({
      earliestStartTime: earliestStartTime
    });
  };

  var onDurationChange = function onDurationChange(stopDuration, waypoint) {
    var waypointIndex = tour.wayPoints.indexOf(waypoint);
    var parsedStopDuration = parseStringToValidNumber(stopDuration);

    var waypointObject = _objectSpread(_objectSpread({}, tour.wayPoints[waypointIndex]), {
      plannedStopDuration: parsedStopDuration
    });

    var wayPoints = tour.wayPoints.slice(0);
    wayPoints.splice(waypointIndex, 1, waypointObject);
    wayPoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: wayPoints
    });
  };

  var _tour$wayPoints3 = tour.wayPoints,
      wayPoints = _tour$wayPoints3 === void 0 ? [] : _tour$wayPoints3;

  var findWaypoint = function findWaypoint(condition) {
    return wayPoints.find(function (wayPoint) {
      return wayPoint.type === condition;
    }) || {};
  };

  var dateNow = new Date();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-128 px-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-12"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.PoiFilter, {
    label: "".concat(intl.formatMessage({
      id: 'widgets.tourBoard.tourstart.selectStartPOI'
    }), "*"),
    value: findWaypoint(_constants.WAYPOINT_TYPES.START).poiId,
    error: errors.wayPoints && errors.wayPoints.find(function (brokenWaypoint) {
      return (brokenWaypoint === null || brokenWaypoint === void 0 ? void 0 : brokenWaypoint.frontendId) === 'startPOI';
    }) ? touched.wayPoints && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.poiId.error",
      tagName: "span"
    }) : null,
    onChange: function onChange(poi) {
      onPoiChange(poi, _constants.WAYPOINT_TYPES.START);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "inline-block fill-blue-500 mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.tourstart.plannedStartTime'
    }),
    selectedDate: findWaypoint(_constants.WAYPOINT_TYPES.START).plannedStartTime,
    locale: locale,
    timezone: timezone,
    enableTime: true,
    onChange: function onChange(date) {
      return onDateChange(date, _constants.WAYPOINT_TYPES.START);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "inline-block fill-blue-500 mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.tourDate'
    }),
    selectedDate: tour.earliestStartTime,
    locale: locale,
    timezone: timezone,
    enableTime: true,
    error: errors.earliestStartTime ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.datePicker.error",
      tagName: "span"
    }) : null,
    minDate: dateNow.toISOString(),
    onChange: onEarliestStartTimeChanged
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-500 mb-8"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.earliestStartTimeExplanationText"
  })), tour.wayPoints.filter(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.INTERMEDIATE;
  }).map(function (waypoint, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "intermediate-waypoint-".concat(waypoint.frontendId),
      className: _procedureStepModule["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _procedureStepModule["default"].numberContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _procedureStepModule["default"].number
    }, index + 1)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex w-96 items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.PoiFilter, {
      label: "".concat(intl.formatMessage({
        id: 'widgets.tourBoard.selectWaypoint'
      }), "*"),
      value: waypoint.poiId,
      error: errors.wayPoints && errors.wayPoints.find(function (brokenWaypoint) {
        var _waypoint$frontendId;

        return (brokenWaypoint === null || brokenWaypoint === void 0 ? void 0 : brokenWaypoint.frontendId) === ((_waypoint$frontendId = waypoint.frontendId) === null || _waypoint$frontendId === void 0 ? void 0 : _waypoint$frontendId.toString());
      }) ? touched.wayPoints && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.poiId.error",
        tagName: "span"
      }) : null,
      onChange: function onChange(poi) {
        onPoiChange(poi, _constants.WAYPOINT_TYPES.START, waypoint);
      }
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: _procedureStepModule["default"].removeWaypoint,
      onClick: function onClick() {
        return onRemoveClicked(waypoint);
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-baseline w-96"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
      className: "inline-block fill-blue-500 mr-2"
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
      inputLabel: intl.formatMessage({
        id: 'widgets.tourBoard.waypoint.scheduledTimeOfArrival'
      }),
      selectedDate: waypoint.scheduledTimeOfArrival,
      locale: locale,
      timezone: timezone,
      enableTime: true,
      onChange: function onChange(date) {
        return onDateChange(date, _constants.WAYPOINT_TYPES.INTERMEDIATE, waypoint);
      }
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      type: "text",
      className: "ml-2",
      label: intl.formatMessage({
        id: 'widgets.tourBoard.waypoint.stopDuration'
      }),
      name: "stopDuration",
      value: Number.isFinite(waypoint.plannedStopDuration) ? waypoint.plannedStopDuration.toString() : '',
      onChange: function onChange(stopDuration) {
        return onDurationChange(stopDuration, waypoint);
      }
    }))));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "add-text-primary inline-flex items-center cursor-pointer font-bold my-4",
    onClick: onAddClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "inline-block fill-primary mr-2 cursor-pointer"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.addWaypoint",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.PoiFilter, {
    label: "".concat(intl.formatMessage({
      id: 'widgets.tourBoard.tourend.selectEndPOI'
    }), "*"),
    value: findWaypoint(_constants.WAYPOINT_TYPES.END).poiId,
    error: errors.wayPoints && errors.wayPoints.find(function (brokenWaypoint) {
      return (brokenWaypoint === null || brokenWaypoint === void 0 ? void 0 : brokenWaypoint.frontendId) === 'endPOI';
    }) ? touched.wayPoints && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.poiId.error",
      tagName: "span"
    }) : null,
    onChange: function onChange(poi) {
      onPoiChange(poi, _constants.WAYPOINT_TYPES.END);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "inline-block fill-blue-500 mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.waypoint.scheduledTimeOfArrival'
    }),
    selectedDate: findWaypoint(_constants.WAYPOINT_TYPES.END).scheduledTimeOfArrival,
    locale: locale,
    timezone: timezone,
    enableTime: true,
    onChange: function onChange(date) {
      return onDateChange(date, _constants.WAYPOINT_TYPES.END);
    }
  })))));
};

exports.Procedure = Procedure;

var noop = function noop() {};

Procedure.propTypes = {
  tour: _propTypes["default"].shape({
    scheduledStartTime: _propTypes["default"].string,
    earliestStartTime: _propTypes["default"].string,
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      type: _propTypes["default"].string
    })),
    wayPoints: _propTypes["default"].instanceOf(Object),
    etaProvider: _propTypes["default"].string
  }).isRequired,
  errors: _propTypes["default"].shape({
    earliestStartTime: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      poiId: _propTypes["default"].string,
      frontendId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    }))
  }),
  touched: _propTypes["default"].shape(),
  onUpdate: _propTypes["default"].func
};
Procedure.defaultProps = {
  errors: {},
  touched: {},
  onUpdate: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Procedure);

exports["default"] = _default;